<template>
  <div class="vote-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="投票主标题" prop="title" style="width: 500px">
          <el-input v-model="form.title" placeholder="请输入投票主标题，最多不超过10个字" maxlength="10" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="投票副标题" prop="subTitle" style="width: 500px">
          <el-input v-model="form.subTitle" placeholder="请输入投票副标题，最多不超过20个字" maxlength="20" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="投票日期" prop="time" style="width: 500px">
          <el-date-picker v-model="form.time" type="daterange" start-placeholder="活动开始日期" end-placeholder="活动结束日期" prefix-icon="el-icon-date" class="custom-date" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="投票简介" prop="introduction" style="width: 744px">
          <el-input v-model="form.introduction" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item label="投票说明" prop="instructions" style="width: 744px">
          <el-input v-model="form.instructions" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item label="投票选项" prop="options" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.options" :label="0">单选</el-radio>
            <el-radio v-model="form.options" :label="1">多选</el-radio>
          </div>
        </el-form-item>
        <el-form-item v-if="form.options === 1" label="多选上限" prop="multiSelectMax" style="width: 500px">
          <el-input v-model="form.multiSelectMax" placeholder="请输入" oninput="value=value.replace('/^[1-9]\d*$/','')" :min="1" type="number" />
        </el-form-item>
        <el-form-item label="投票规则" prop="rules" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.rules" :label="0">每人每天可投票1次</el-radio>
            <el-radio v-model="form.rules" :label="1">有效期内每人仅可投票1次</el-radio>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="coverImage" class="image-config" style="padding-bottom: 20px;">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.coverImage.mainImage" title="投票页主图" size-tips="1125px*1125px" :save-path="savePath" @upload="uploader($event,'mainImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.coverImage.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :save-path="savePath" :limit-size="2" @upload="uploader($event,'shareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.coverImage.endBannerImage" title="投票结束页主图" size-tips="1125px*1125px" :save-path="savePath" @upload="uploader($event,'endBannerImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.coverImage.shareImage" title="投票活动分享图片" size-tips="849px*849px" :save-path="savePath" @upload="uploader($event,'shareImage')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="页面跳转banner" class="image-config banner-wrap">
          <div class="flex banner-box">
            <el-form-item label="标题" class="banner-title h-view align-center">
              <el-input v-model="form.linkToTitle" style="width: 360px;" placeholder="请输入标题，最多10个字" maxlength="10" />
            </el-form-item>
            <UploadImage :url="form.linkToImage" size-tips="1200px*600px" :save-path="savePath" @upload="uploaderBanner($event,'linkToImage')" @triggerReg="handleCheckReg" />
            <el-form-item label="链接地址" class="link-box h-view align-center">
              <el-input v-model="form.linkToUrl" style="width: 360px;" placeholder="请输入链接地址" />
            </el-form-item>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <div class="configure-tiem-title">配置投票项目</div>
        <div class="title-box h-view align-center justify-space-between">
          <div class="num flex-shrink">项目序号</div>
          <div class="item-name flex-shrink"><span>*</span>项目名称</div>
          <div class="type-choose h-view align-center flex-shrink">
            <span>*</span>
            <el-select v-model="chooseType" placeholder="请选择" @change="changeType">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div class="describe flex-shrink">描述</div>
          <div class="edit-box">操作</div>
        </div>
        <div class="content-box">
          <div v-for="(item, index) in form.voteItemAddDTO" :key="index" class="every-content h-view align-center justify-space-between">
            <div class="num flex-shrink">{{ index + 1 }}</div>
            <div class="item-name flex-shrink">
              <el-input v-model="item.itemName" placeholder="请输入项目名称" :disabled="disabled" />
            </div>
            <div class="type-choose flex-shrink">
              <UploadImageRatio v-if="chooseType === 0" :url="item.itemUrl" :save-path="savePath" :disabled="disabled" :limit-size="2" size-tips="4:3" :is-show-config="false" @upload="uploaderItemImg($event,index)" />
              <UploadVideo v-if="chooseType === 1" :url="item.itemUrl" :save-path="savePath" :disabled="disabled" :duration="15" :limit-size="25" size-tips="16:9" :is-show-config="false" @upload="uploadVideo($event,index)" />
            </div>
            <div class="describe flex-shrink">
              <el-input v-model="item.description" type="textarea" :rows="2" maxlength="25" placeholder="请输入投票副标题，最多不超过25个字（包括符号）" />
            </div>
            <div class="edit-box" @click="deleteVoteItem(index)">删除</div>
          </div>
        </div>
        <div class="add-box h-view align-center justify-center">
          <div class="add-btns h-view align-center justify-center" @click="add"><i class="el-icon-plus">添加投票项目</i></div>
        </div>
        <el-form-item style="width:100%;margin-top:80px;" class="sub-edit-btn">
          <div class="h-view justify-center btns">
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import UploadImage from '@/components/UploadImage';
import UploadImageRatio from '@/components/UploadImageRatio';
import UploadVideo from '@/components/UploadVideo';
import { VoteConfig } from '@/model/VoteConfig';
import Dialog from '@/components/Dialog';
import {
  postVoteCreate,
  postVoteUpdate,
  voteDetails,
} from '@/api/voteConfig';
export default {
  components: { UploadImage, UploadImageRatio, Dialog, UploadVideo },
  data() {
    return {
      form: new VoteConfig(),
      disabled: false,
      formDialogShow: false,
      information: {},
      savePath: 'ua_activity/detail/',
      cancelText: '',
      rules: {
        title: [
          { required: true, message: '请输入投票主标题', trigger: ['change', 'blur'] },
        ],
        subTitle: [
          { required: true, message: '请输入投票副标题', trigger: ['change', 'blur'] },
        ],
        time: [
          { type: 'array', required: true, message: '请选择投票日期', trigger: ['change', 'blur'] },
        ],
        introduction: [
          { required: true, message: '请输入投票简介', trigger: ['change', 'blur'] },
        ],
        instructions: [
          { required: true, message: '请输入投票说明', trigger: ['change', 'blur'] },
        ],
        options: [
          { required: true, message: '请选择投票选项', trigger: ['change'] },
        ],
        multiSelectMax: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value || value < 1) {
                callback(new Error('多选上限至少为1'));
              } else {
                callback();
              }
            }, trigger: ['change', 'blur'],
          },
        ],
        rules: [
          { required: true, message: '请选择投票规则', trigger: ['change'] },
        ],
        coverImage: {
          required: true, validator: (rule, value, callback) => {
            const array = [];
            for (const key in value) {
              array.push(value[key]);
            }
            if (array.length !== 4 || array.some((item) => !item)) {
              callback(new Error('请上传图片'));
            } else {
              callback();
            }
          }, trigger: ['change'],
        },
      },
      typeOptions: [
        {
          label: '图片（支持*.png/*.jpg，不超过2M，尺寸4:3）',
          value: 0,
        },
        {
          label: '视频（不超过25M，时长15s内，尺寸16:9）',
          value: 1,
        },
      ],
      chooseType: 0,
    };
  },
  mounted() {
    const { query } = this.$route;
    const id = query.id || query.copyid;
    if (id) {
      this.getActivityDetail(id);
    }
    this.cancelText = query.id ? '编辑' : '新增';
  },
  methods: {
    handleCheckReg() {
      this.$refs.form.validateField("coverImage");
    },
    uploader(file, key) {
      this.form.coverImage[key] = file;
      this.$forceUpdate();
    },
    uploaderItemImg(file, i) {
      this.form.voteItemAddDTO[i].itemUrl = file;
    },
    uploadVideo(file, i) {
      this.form.voteItemAddDTO[i].itemUrl = file;
    },
    add() {
      const obj = {
        description: '',
        itemName: '',
        itemType: this.chooseType,
        itemUrl: '',
      };
      this.form.voteItemAddDTO.push(obj);
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    goBack() {
      this.$router.back(-1);
    },
    uploaderBanner(file) {
      this.form.linkToImage = file;
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          console.log(valid, 11);
          if (valid) {
            // debugger
            if (this.form.voteItemAddDTO.length === 0) {
              this.$message.error('请添加配置投票项目');
              return true;
            } else {
              let isSure = true;
              for (let i = 0, length = this.form.voteItemAddDTO.length; i < length; i++) {
                const item = this.form.voteItemAddDTO[i];
                if (!item.itemName || !item.itemUrl) {
                  isSure = false;
                  break;
                }
              }
              if (!isSure) {
                this.$message.error('请完善配置投票项目');
                return true;
              }
            }
            if (this.$route.query.id) {
              this.editVote();
            } else {
              this.addVote();
            }
          } else {
            return false;
          }
        });
      }
    },
    addVote() {
      delete this.form.id;
      const param = { ...this.form };
      postVoteCreate(param).then((data) => {
        console.log(data);
        this.$message.success('新增成功');
        this.goBack();
      });
    },
    editVote() {
      this.form.voteItemUpdateDTOS = this.form.voteItemAddDTO;
      postVoteUpdate(this.form).then((data) => {
        console.log(data);
        this.$message.success('编辑成功');
        this.goBack();
      });
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意投票配置状态，保存后已发布的投票配置将实时更新至UA HOUSE小程序",
      };
    },
    deleteVoteItem(i) {
      this.form.voteItemAddDTO.splice(i, 1);
    },
    changeType() {
      this.form.voteItemAddDTO = [];
    },
    getActivityDetail(id) {
      voteDetails(id)
        .then((data) => {
          console.log(data, '===>data');
          this.form = new VoteConfig(data);
          console.log(this.form, '====>this.from');
          if (data.voteItemDetailsVOS && data.voteItemDetailsVOS.length > 0) {
            this.chooseType = data.voteItemDetailsVOS[0].itemType;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.vote-edit {
  .marginTop {
    margin-top: 30px;
  }
  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    line-height: 32px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .el-form-item--small.el-form-item .form-radio {
    line-height: 32px;
    height: 32px;
    align-items: center;
  }
  .image-config {
    overflow: hidden;
    /deep/ .el-form-item__label {
      float: none !important;
    }
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .banner-wrap {
    .banner-box {
      margin-top: 20px;
      padding: 30px 10px;
      background: #f7f7f7;
      /deep/.el-form-item__label {
        width: 70px !important;
      }
      .banner-title {
        margin-right: 60px;
        flex-shrink: 0;
      }
      .el-form-item--small.el-form-item {
        margin-bottom: 0 !important;
      }

      .link-box {
        flex-shrink: 0;
        margin-left: 30px;
      }
    }
  }

  .configure-tiem-title {
    line-height: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
  }
  .uploadImg-cont {
    margin-top: 20px;
  }
  .title-box {
    margin-top: 20px;
    height: 50px;
    background: #494949;
    font-size: 14px;
    color: #fff;
    padding: 0 30px;
    .num {
      width: 70px;
    }
    .item-name {
      width: 150px;
      span {
        margin-right: 4px;
        color: #dc0019;
      }
    }
    .type-choose {
      width: 330px;
      span {
        color: #dc0019;
      }
      .el-select {
        width: 330px;
        .el-input__inner {
          padding-left: 4px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
      }
    }
    .describe {
      width: 250px;
    }
    .edit-box {
      width: 40px;
    }
  }
  .every-content {
    padding: 10px 30px;
    .num {
      width: 70px;
    }
    .item-name {
      .el-input__inner {
        width: 150px;
      }
    }
    .type-choose {
      width: 320px;
      padding-left: 30px;
      box-sizing: border-box;
    }
    .describe {
      width: 250px;
      .el-textarea__inner {
        width: 240px;
      }
    }
    .edit-box {
      width: 40px;
      font-size: 14px;
      color: #0085d0;
      cursor: pointer;
    }
  }
  .add-box {
    height: 93px;
    background: #f7f7f7;
  }
  .add-btns {
    height: 34px;
    width: 140px;
    display: inline-block;
    border: 1px dashed #bbbbbb;
    color: #bbbbbb;
    // padding: 0px 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  .sub-edit-btn {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  /*水平布局*/
  .h-view {
    display: flex;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  /*垂直布局*/
  .v-view {
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  /* 盒子自适应换行 */
  .flex-wrap {
    flex-wrap: wrap;
  }

  .flex1 {
    flex: 1;
  }

  .flex-nowrap {
    flex-wrap: nowrap;
  }

  .flex-shrink {
    flex-shrink: 0;
  }

  .align-start {
    align-items: flex-start;
  }

  .align-center {
    align-items: center;
  }

  .align-end {
    align-items: flex-end;
  }

  .align-baseline {
    align-items: baseline;
  }

  .align-stretch {
    align-items: stretch;
  }

  .justify-start {
    justify-content: flex-start;
  }

  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-space-between {
    justify-content: space-between;
  }
  .justify-space-around {
    justify-content: space-around;
  }
}
</style>
